import { adjustColor, hexToRgba } from '../utils/colorUtils';

function buildCss(c, cL, cD, ca04, ca10) {
  return `
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@300;400;700&display=swap');

.cs { font-family: 'Noto Serif JP', Georgia, serif; background: #fff; width: 100%; }

.cs-nav {
  background: ${c}; padding: 18px 64px;
  display: flex; justify-content: space-between; align-items: center;
  box-shadow: 0 4px 24px rgba(0,0,0,0.22); position: relative; z-index: 10;
}
.cs-nav-logo { color: #fff; font-size: 22px; font-weight: 700; letter-spacing: 0.05em; }
.cs-nav-links { display: flex; gap: 36px; }
.cs-nav-link { color: rgba(255,255,255,0.85); font-size: 14px; cursor: pointer; transition: color 0.2s; }
.cs-nav-link:hover { color: ${cL}; }

.cs-hero { position: relative; height: 580px; overflow: hidden; }
.cs-hero-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; }
.cs-hero-overlay {
  position: absolute; inset: 0; background: ${hexToRgba(c, 0.62)};
  display: flex; flex-direction: column; justify-content: center; align-items: center;
  padding: 0 80px; text-align: center;
}
.cs-hero-industry { color: ${cL}; font-size: 13px; letter-spacing: 0.25em; margin-bottom: 24px; }
.cs-hero-h1 {
  color: #fff; font-size: 52px; line-height: 1.45; margin-bottom: 24px;
  text-shadow: 0 2px 28px rgba(0,0,0,0.5);
}
.cs-hero-tagline { color: rgba(255,255,255,0.88); font-size: 18px; max-width: 560px; }
.cs-hero-btn {
  margin-top: 48px; padding: 15px 56px; background: ${cL}; color: #fff;
  border: none; font-size: 16px; cursor: pointer; letter-spacing: 0.1em; font-family: inherit;
  transition: background 0.2s, transform 0.2s;
}
.cs-hero-btn:hover { background: ${cD}; transform: translateY(-2px); }

.cs-features { padding: 96px 64px; background: #f7f8fa; }
.cs-section-label { text-align: center; color: ${cL}; font-size: 12px; letter-spacing: 0.3em; margin-bottom: 14px; }
.cs-section-h2 { text-align: center; color: ${c}; font-size: 34px; margin-bottom: 18px; }
.cs-gold-divider { width: 56px; height: 2px; background: ${cL}; margin: 0 auto 64px; }
.cs-features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; }
.cs-feature-card {
  background: #fff; padding: 40px 36px; border-top: 3px solid ${c};
  box-shadow: 0 2px 16px rgba(0,0,0,0.06); transition: transform 0.2s, box-shadow 0.2s;
}
.cs-feature-card:hover { transform: translateY(-4px); box-shadow: 0 10px 36px ${ca10}; }
.cs-feature-num {
  width: 44px; height: 44px; background: ${c}; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 20px; margin-bottom: 22px;
}
.cs-feature-title { color: ${c}; font-size: 20px; margin-bottom: 14px; }
.cs-feature-desc { color: #666; line-height: 1.9; font-size: 15px; }

.cs-ceo { padding: 96px 64px; display: flex; gap: 72px; align-items: center; }
.cs-ceo-img-wrap { position: relative; width: 340px; height: 340px; overflow: hidden; flex-shrink: 0; background-color: #f5f5f5; }
.cs-ceo-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; object-position: center; display: block; }
.cs-ceo-label { color: ${cL}; font-size: 12px; letter-spacing: 0.25em; margin-bottom: 20px; }
.cs-ceo-h2 { color: ${c}; font-size: 34px; margin-bottom: 28px; }
.cs-ceo-desc { color: #444; line-height: 2.1; font-size: 16px; max-width: 520px; }
.cs-ceo-meta { margin-top: 40px; padding-top: 28px; border-top: 1px solid ${ca10}; }
.cs-ceo-role { color: #888; font-size: 13px; letter-spacing: 0.1em; margin-bottom: 6px; }
.cs-ceo-name { color: ${c}; font-size: 22px; }

.cs-news { padding: 72px 64px; background: #f7f8fa; }
.cs-news-h2 { color: ${c}; font-size: 28px; margin-bottom: 36px; }
.cs-news-item {
  display: flex; gap: 28px; padding: 20px 12px; border-bottom: 1px solid #ddd;
  align-items: center; transition: background 0.2s; cursor: pointer; border-radius: 4px;
}
.cs-news-item:hover { background: ${ca04}; }
.cs-news-date { color: #999; font-size: 13px; min-width: 100px; font-family: system-ui; }
.cs-news-title { color: #333; font-size: 16px; }

.cs-cta {
  padding: 96px 64px; text-align: center; background-color: ${c};
  background-image: repeating-linear-gradient(45deg, transparent, transparent 12px, rgba(255,255,255,0.025) 12px, rgba(255,255,255,0.025) 24px);
}
.cs-cta-h2 { color: #fff; font-size: 36px; margin-bottom: 20px; }
.cs-cta-desc { color: rgba(255,255,255,0.75); font-size: 17px; max-width: 560px; margin: 0 auto 52px; line-height: 1.8; }
.cs-cta-btn {
  padding: 17px 68px; background: ${cL}; color: #fff; border: none;
  font-size: 18px; cursor: pointer; font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.cs-cta-btn:hover { background: ${cD}; transform: translateY(-2px); }

.cs-footer { background: #111; padding: 36px 64px; display: flex; justify-content: space-between; align-items: center; }
.cs-footer-logo { color: #fff; font-size: 18px; }
.cs-footer-copy { color: #555; font-size: 13px; }

@media (max-width: 768px) {
  .cs-nav { padding: 14px 20px; }
  .cs-nav-links { display: none; }
  .cs-hero { height: 380px; }
  .cs-hero-overlay { padding: 0 24px; }
  .cs-hero-h1 { font-size: 26px; }
  .cs-hero-tagline { font-size: 14px; }
  .cs-features { padding: 56px 20px; }
  .cs-features-grid { grid-template-columns: 1fr; gap: 20px; }
  .cs-ceo { flex-direction: column; padding: 56px 20px; gap: 32px; }
  .cs-ceo-img-wrap { width: 100%; height: 240px; }
  .cs-news { padding: 48px 20px; }
  .cs-cta { padding: 64px 20px; }
  .cs-cta-h2 { font-size: 26px; }
  .cs-footer { padding: 24px 20px; flex-direction: column; gap: 8px; text-align: center; }
}
`;
}

export default function CorporateStandard({ data }) {
  const c   = data.color || '#1e3a5f';
  const cL  = adjustColor(c, 28);
  const cD  = adjustColor(c, -15);
  const ca04 = hexToRgba(c, 0.04);
  const ca10 = hexToRgba(c, 0.1);

  return (
    <>
      <style>{buildCss(c, cL, cD, ca04, ca10)}</style>
      <div className="cs">
        <nav className="cs-nav">
          <span className="cs-nav-logo">{data.siteName}</span>
          <div className="cs-nav-links">
            {['事業内容', 'サービス', '会社概要', 'お問い合わせ'].map(item => (
              <span key={item} className="cs-nav-link">{item}</span>
            ))}
          </div>
        </nav>

        <div className="cs-hero">
          <img src={data.heroImage} alt="" className="cs-hero-img" />
          <div className="cs-hero-overlay">
            <p className="cs-hero-industry">{data.industry}</p>
            <h1 className="cs-hero-h1">{data.heroHeading}</h1>
            <p className="cs-hero-tagline">{data.tagline}</p>
            <button className="cs-hero-btn">{data.cta}</button>
          </div>
        </div>

        <div className="cs-features">
          <p className="cs-section-label">BUSINESS</p>
          <h2 className="cs-section-h2">事業紹介</h2>
          <div className="cs-gold-divider" />
          <div className="cs-features-grid">
            {data.features.map((f, i) => (
              <div key={i} className="cs-feature-card">
                <div className="cs-feature-num">{i + 1}</div>
                <h3 className="cs-feature-title">{f.title}</h3>
                <p className="cs-feature-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="cs-ceo">
          <div className="cs-ceo-img-wrap">
            <img src={data.images[0]} alt="" className="cs-ceo-img" />
          </div>
          <div>
            <p className="cs-ceo-label">MESSAGE</p>
            <h2 className="cs-ceo-h2">代表メッセージ</h2>
            <p className="cs-ceo-desc">{data.description}</p>
            <div className="cs-ceo-meta">
              <p className="cs-ceo-role">代表取締役社長</p>
              <p className="cs-ceo-name">山田 太郎</p>
            </div>
          </div>
        </div>

        <div className="cs-news">
          <h2 className="cs-news-h2">お知らせ</h2>
          {data.news.map((n, i) => (
            <div key={i} className="cs-news-item">
              <span className="cs-news-date">{n.date}</span>
              <span className="cs-news-title">{n.title}</span>
            </div>
          ))}
        </div>

        <div className="cs-cta">
          <h2 className="cs-cta-h2">まずはお気軽にご相談ください</h2>
          <p className="cs-cta-desc">{data.description}</p>
          <button className="cs-cta-btn">{data.cta}</button>
        </div>

        <footer className="cs-footer">
          <span className="cs-footer-logo">{data.siteName}</span>
          <span className="cs-footer-copy">© 2025 {data.siteName}. All rights reserved.</span>
        </footer>
      </div>
    </>
  );
}
